<template>
  <div class="hm-folio">
    <div v-if="$route.params.roomId" class="hm-folio__content">
      <div class="hm-folio__top">
        <app-cells position="between">
          <div class="hm-folio__content-guests">
            <div
              v-for="(_, idx) in room.short_room.accomodation_type.pax"
              :key="idx"
              class="hm-folio__content-guest"
            >
              <template v-if="room.guests[idx]">
                <span class="hm-folio__gender">
                  <MaleIcon v-if="room.guests[idx].gender && room.guests[idx].gender.code === 'male'"/>
                  <FemaleIcon v-else-if="room.guests[idx].gender && room.guests[idx].gender.code === 'female'"/>
                </span>
                <HMTooltip>
                  <template #trigger>
                    <span
                      :class="{ 'hm-folio__flag--empty': !(room.guests[idx].citizenship && room.guests[idx].citizenship.code) }"
                      :title="room.guests[idx].citizenship && room.guests[idx].citizenship.name ? room.guests[idx].citizenship.name : ''"
                      class="hm-folio__flag"
                    >
                      <span
                        v-if="room.guests[idx].citizenship && room.guests[idx].citizenship.code"
                        :class="`fflag ff-md fflag-${room.guests[idx].citizenship.code}`"
                      ></span>
                    </span>
                  </template>
                  <template #content>{{ room.guests[idx].citizenship?.name }}</template>
                </HMTooltip>
                <span class="hm-folio__guest-name">
                  {{
                    (room.guests[idx].gender && room.guests[idx].gender.greeting) ? room.guests[idx].gender.greeting : ''
                  }} {{
                    room.guests[idx].full_name || ((room.guests[idx].first_name || '') + ' ' + (room.guests[idx].last_name || ''))
                  }}
                </span>
              </template>
              <template>
                <!--                <button @click="onShowModalGuests" class="hm-dashboard__add-guest">-->
                <!--                  <PlusSmallGreen/>-->
                <!--                </button>-->
                <!--                <button class="hm-dashboard__add-guest">-->
                <!--                  <PlusSmallGreen/>-->
                <!--                </button>-->
                <!--                <span class="hm-folio__guest-name">Guest #{{ idx + 1 }} - Unknown</span>-->
              </template>
            </div>
          </div>
          <div ref="statusRootFolio" class="hm-folio__status">
            <button
              :disabled="room.status.available_statuses.length < 1"
              :style="{ color: currentStatusColor }"
              class="hm-folio__status-btn"
              type="button"
              @click="toggleStatus"
            >
              <span class="hm-folio__status-text">{{ room.status.name }}</span>
              <svg v-if="room.status.available_statuses.length > 0" aria-hidden="true" class="hm-folio__status-caret"
                   height="20" viewBox="0 0 24 24" width="20">
                <path d="M7 10l5 5 5-5" fill="none" stroke="currentColor" stroke-width="2"/>
              </svg>
            </button>
            <transition name="hm-status-fade">
              <div
                v-if="isStatusOpen && room.status.available_statuses && room.status.available_statuses.length > 0"
                class="hm-folio__status-dropdown"
              >
                <div
                  v-for="opt in room.status.available_statuses"
                  :key="opt.code"
                  :class="{ 'hm-folio__status-option--selected': opt.code === room.status.code }"
                  :style="{ color: opt.color || '#000' }"
                  class="hm-folio__status-option"
                  @click="onSelectStatus(opt)"
                >
                  {{ opt.name }}
                </div>
              </div>
            </transition>
          </div>
        </app-cells>
        <app-cells v-if="isHotelReception || isGeneralManager || isHotelReservations">
          <HMButton @click.native="onShowModalPayment"><span>Add Payment</span></HMButton>
          <HMButton @click.native="onShowModalService" background="linear-gradient(0deg, #FFCDB5 0%, #FBE0D2 100%)" color="#A4744A">
            <span>Add Service</span>
          </HMButton>
        </app-cells>
      </div>
      <template v-if="transactionItems.length > 0">
        <HMFolioList @postVoid="onVoidTransaction" :transactions="transactionItems" />
        <div class="hm-folio__total">
          <span></span>
          <span></span>
          <span></span>
          <span class="hm-folio__total-val">Total:</span>
          <span class="hm-folio__total-val hm-folio__neg">{{ formatMoney(room.debit) }}</span>
          <span class="hm-folio__total-val hm-folio__pos">{{ formatMoney(room.credit) }}</span>
        </div>
        <div class="hm-folio__bottom">
          <app-cells :indent="false" position="between">
            <app-cells :indent="false">
              <HMButton
                @click.native="onExport"
                :loading="isExportFolio"
                background="linear-gradient(180deg, #DAEDFD 0%, #D2E7FB 100%)" color="#499DAE"
              >
                <PrintIcon/>
                <span>Print The Folio</span>
              </HMButton>
              <div v-if="room.folio_printed_at" class="hm-folio__printed">
                <span>Printed:</span>
                <span>{{ formatDate(room.folio_printed_at) }},</span>
                <span>by <span class="hm-folio__printed-name">{{ room.folio_printed_by.full_name }}</span></span>
                <div aria-hidden="true" class="hm-folio__printed-ava">
                  <img :src="getUserAvatar(room.folio_printed_by.crop.crop_url)" alt="Avatar" class="hm-folio__printed-ava-img" />
                </div>
              </div>
            </app-cells>
            <div class="hm-folio__balance">
              Balance:
              <HMBalance :balance="room.balance"/>
            </div>
          </app-cells>
        </div>
      </template>
      <HMSlug v-else style="margin: 0 20px 20px;">
        <template #img><img alt="Services" src="@/assets/img/hm-services.png"/></template>
        <template #title>No services or payments yet</template>
        <template #text>All future services and charges will appear here once added.</template>
      </HMSlug>
    </div>
    <HMSlug v-else>
      <template #img><img alt="Bed" src="@/assets/img/hm-bed.png"/></template>
      <template #title>No room selected</template>
      <template #text>Please choose a room from the list to view its details and continue with your booking.</template>
    </HMSlug>
    <modal
      :adaptive="true"
      :clickToClose="false"
      :height="'auto'"
      :reset="true"
      :scrollable="true"
      :width="700"
      name="guest-form"
    >
      <div class="popup-new">
        <button class="popup-new__close" type="button" @click="$modal.hide('guest-form')"></button>
        <div class="popup-new__title">Add Guest</div>
        <div class="popup-new__body">
          <form @submit.prevent="onCheckForm('guestForm', 'onSaveGuests')">
            <app-grid>
              <template #item-1>
                <app-form-field :marginBottom="20" class="family" label="First Name" label-for="first_name" required>
                  <app-input
                    id="first_name"
                    v-model="guestForm.first_name"
                    :error="$v.guestForm.first_name.$error"
                    class="family"
                    placeholder="First Name"
                  />
                  <template #error>
                    <div v-if="$v.guestForm.first_name.$dirty && !$v.guestForm.first_name.required">Required
                      field
                    </div>
                  </template>
                </app-form-field>
                <app-form-field :marginBottom="20" class="family" label="Last Name" label-for="last_name" required>
                  <app-input
                    id="last_name"
                    v-model="guestForm.last_name"
                    :error="$v.guestForm.last_name.$error"
                    class="family"
                    placeholder="Last Name"
                  />
                  <template #error>
                    <div v-if="$v.guestForm.last_name.$dirty && !$v.guestForm.last_name.required">Required
                      field
                    </div>
                  </template>
                </app-form-field>
                <app-form-field :marginBottom="20" class="family" label="Gender">
                  <app-cells :indent="false">
                    <app-radio
                      v-for="item in genders_options"
                      :key="item.code"
                      v-model.number="guestForm.gender"
                      :checked="guestForm.gender"
                      :value="item.code"
                      name="gender"
                    >
                      <template #label>{{ item.name }}</template>
                    </app-radio>
                  </app-cells>
                </app-form-field>
                <app-form-field :marginBottom="20" class="family" label="Date of birth">
                  <app-date-picker
                    v-model="guestForm.dob"
                    class="family"
                    placeholder="Date of birth"
                  />
                </app-form-field>
                <app-form-field :marginBottom="20" class="family" label="Citizenship">
                  <app-select
                    v-model="guestForm.citizenship"
                    :options="countries_options"
                    :reduce="item => item.code"
                    class="family"
                    placeholder="Citizenship"
                  />
                </app-form-field>
                <app-form-field :marginBottom="20" class="family" label="Passport №" label-for="passport">
                  <app-input
                    id="passport"
                    v-model="guestForm.passport"
                    placeholder="Passport №"
                  />
                </app-form-field>
                <app-form-field :marginBottom="20" class="family" label="Email" label-for="email">
                  <app-input
                    id="email"
                    v-model="guestForm.email"
                    :error="$v.guestForm.email.$error"
                    placeholder="Email"
                    type="email"
                  />
                  <template #error>
                    <div v-if="$v.guestForm.email.$dirty && !$v.guestForm.email.email">Enter the correct e-mail format
                    </div>
                  </template>
                </app-form-field>
                <app-form-field :marginBottom="20" class="family" label="Phone">
                  <app-phone
                    v-model="guestForm.phone"
                    :error="$v.guestForm.phone.$dirty && guestForm.phone === 0"
                    placeholder="+255 786 350 350"
                  />
                  <template #error>
                    <div v-if="$v.guestForm.phone.$dirty && guestForm.phone === 0">Invalid phone number format</div>
                  </template>
                </app-form-field>
              </template>
              <template #item-2>
                <app-form-field :marginBottom="20" class="family" label="Food Preferences">
                  <app-select
                    v-model="guestForm.food_preference"
                    :options="food_preference_options"
                    :reduce="item => item.id"
                    class="family"
                    placeholder="Food Preferences"
                  />
                </app-form-field>
                <app-form-field :marginBottom="20" class="family" label="Restrictions">
                  <app-cells :indent="false" style="height: 38px">
                    <app-checkbox
                      v-model="guestForm.food_gluten_free"
                      label="Gluten Free"
                    />
                    <app-checkbox
                      v-model="guestForm.food_lactose_free"
                      label="Lactose Free"
                    />
                    <app-checkbox
                      v-model="guestForm.food_halal"
                      label="Halal"
                    />
                  </app-cells>
                </app-form-field>
                <app-form-field :marginBottom="20" class="family" label="Allergies" label-for="food_allergy">
                  <app-textarea
                    id="food_allergy"
                    v-model="guestForm.food_allergy"
                    placeholder="Allergies"
                  />
                </app-form-field>
              </template>
            </app-grid>
            <app-cells :indent="false" position="center">
              <HMButton :loading="isSubmittingGuestForm">
                <span>Save</span>
              </HMButton>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
    <modal
      :adaptive="true"
      :clickToClose="false"
      :height="'auto'"
      :reset="true"
      :scrollable="true"
      :width="400"
      name="payment-form"
    >
      <div class="popup-new">
        <button class="popup-new__close" type="button" @click="$modal.hide('payment-form')"></button>
        <div class="popup-new__title">Add Payment</div>
        <div class="popup-new__body">
          <form @submit.prevent="onCheckForm('paymentForm', 'onCreatePayment')">
            <app-form-field :marginBottom="20" class="family" label="Method" required>
              <app-cells :indent="false">
                <app-radio
                  v-for="item in method_options"
                  :key="item.code"
                  v-model="paymentForm.method"
                  :checked="paymentForm.method"
                  :value="item.code"
                  class="family"
                  name="method"
                >
                  <template #label>{{ item.name }}</template>
                </app-radio>
              </app-cells>
              <template #error>
                <div v-if="$v.paymentForm.method.$dirty && !$v.paymentForm.method.required">Required field</div>
              </template>
            </app-form-field>
            <app-form-field v-if="paymentForm?.method === 'cash'" :marginBottom="20" label="Currency" required class="family">
              <app-select
                v-model="paymentForm.currency"
                :options="currency_options"
                :clearable="false"
                :reduce="item => item.code"
                placeholder="Currency"
                class="family"
                :error="$v.paymentForm.currency.$error"
              />
              <template #error>
                <div v-if="$v.paymentForm.currency.$dirty && !$v.paymentForm.currency.required">Required field</div>
              </template>
            </app-form-field>
            <app-form-field :marginBottom="20" class="family" label="Amount" label-for="paymentAmount" required>
              <app-fin-number
                v-model="paymentForm.amount"
                id="paymentAmount"
                name="paymentAmount"
                placeholder="0"
                :error="$v.paymentForm.amount.$error"
              />
              <template #error>
                <div v-if="$v.paymentForm.amount.$dirty && !$v.paymentForm.amount.required">Required field</div>
              </template>
            </app-form-field>
            <app-form-field :marginBottom="20" class="family" label="Notes" label-for="paymentNotes">
              <app-textarea
                v-model="paymentForm.notes"
                id="paymentNotes"
                placeholder="Notes"
                class="family"
              />
            </app-form-field>
            <app-cells :indent="false" position="center">
              <HMButton :loading="isSubmittingPaymentForm"><span>Create</span></HMButton>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
    <modal
      :adaptive="true"
      :clickToClose="false"
      :height="'auto'"
      :reset="true"
      :scrollable="true"
      :width="400"
      name="service-form"
    >
      <div class="popup-new">
        <button class="popup-new__close" type="button" @click="$modal.hide('service-form')"></button>
        <div class="popup-new__title">Add Service</div>
        <div class="popup-new__body">
          <form @submit.prevent="onCheckForm('serviceForm', 'onCreateService')">
            <app-form-field :marginBottom="20" label="Category" class="family" required>
              <app-select
                v-model="serviceForm.transaction_category"
                :options="transaction_categories_options"
                :clearable="false"
                placeholder="Category"
                class="family"
                :error="$v.serviceForm.transaction_category.$error"
              />
              <template #error>
                <div v-if="$v.serviceForm.transaction_category.$dirty && !$v.serviceForm.transaction_category.required">Required field</div>
              </template>
            </app-form-field>
            <app-form-field :marginBottom="20" class="family" label="Amount" label-for="serviceAmount" required>
              <app-fin-number
                v-model="serviceForm.amount"
                id="serviceAmount"
                placeholder="0"
                :error="$v.serviceForm.amount.$error"
              />
              <template #error>
                <div v-if="$v.serviceForm.amount.$dirty && !$v.serviceForm.amount.required">Required field</div>
              </template>
            </app-form-field>
            <app-form-field :marginBottom="20" class="family" label="Notes" label-for="serviceNotes" :required="serviceForm?.transaction_category?.notes_required">
              <app-textarea
                v-model="serviceForm.notes"
                id="serviceNotes"
                placeholder="Notes"
                class="family"
                :error="$v.serviceForm.notes.$error"
              />
              <template #error>
                <div v-if="$v.serviceForm.notes.$dirty && !$v.serviceForm.notes.required">Required field</div>
              </template>
            </app-form-field>
            <app-cells :indent="false" position="center">
              <HMButton :loading="isSubmittingServiceForm"><span>Add</span></HMButton>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import {
  getCountries,
  getFoodPreferences,
  getGenders,
  patchHotelManagementReservationsRooms,
  postHotelManagementPaymentsCreateSingle,
  getHotelManagementTransactions,
  getHotelManagementTransactionCategories,
  postHotelManagementTransactions, getHotelManagementExportFolio
} from '@/http'
// import HMSwitcher from '@/views/hotel-management/reservations/components/HMSwitcher.vue'
import PrintIcon from '@/views/hotel-management/reservations/detail/icons/PrintIcon.vue'
import MaleIcon from '@/views/hotel-management/reservations/detail/icons/MaleIcon.vue'
import FemaleIcon from '@/views/hotel-management/reservations/detail/icons/FemaleIcon.vue'
import HMFolioList from '@/views/hotel-management/reservations/components/HMFolioList.vue'
import HMSlug from '@/views/hotel-management/reservations/components/HMSlug.vue'
import HMTooltip from '@/views/hotel-management/reservations/components/HMTooltip.vue'
import HMBalance from '@/views/hotel-management/reservations/components/HMBalance.vue'
import { email, required, requiredIf } from 'vuelidate/lib/validators'
import HMButton from '@/views/hotel-management/reservations/components/HMButton.vue'

export default {
  name: 'HotelManagementReservationsRoomsDetail',
  props: {
    room: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    HMButton,
    HMBalance,
    HMTooltip,
    HMSlug,
    HMFolioList,
    PrintIcon,
    // HMSwitcher,
    FemaleIcon,
    MaleIcon
  },
  data() {
    return {
      printed: false,
      isStatusOpen: false,
      transactionItems: [],
      guestForm: {},
      paymentForm: {},
      serviceForm: {},
      isSubmittingGuestForm: false,
      isSubmittingPaymentForm: false,
      isSubmittingServiceForm: false,
      isExportFolio: false,
      genders_options: [],
      countries_options: [],
      food_preference_options: [],
      transaction_categories_options: [],
      currency_options: [
        {code: 'USD', name: 'US Dollars'},
        {code: 'TZS', name: 'Tanzanian Shillings'},
        {code: 'EUR', name: 'Euro'},
      ],
      method_options: [
        {code: 'cash', name: 'Cash'},
        {code: 'card', name: 'Credit Card'},
        {code: 'lipa', name: 'LIPA'},
      ],
    }
  },
  validations: {
    guestForm: {
      first_name: {required},
      last_name: {required},
      email: {email},
      phone: {},
    },
    paymentForm: {
      method: {required},
      amount: {required},
      currency: {
        required: requiredIf(function() {
          return this.paymentForm?.method === 'cash'
        })
      },
    },
    serviceForm: {
      transaction_category: {required},
      amount: {required},
      notes: {
        required: requiredIf(function() {
          return this.serviceForm?.transaction_category?.notes_required
        })
      },
    }
  },
  computed: {
    currentStatusColor() {
      return this.room.status && this.room.status.color ? this.room.status.color : '#000'
    },
    isHotelReception() {
      return this.$store.state.userGroups.map(item => item.code).includes('hotel_reception')
    },
    isGeneralManager() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager')
    },
    isHotelReservations() {
      return this.$store.state.userGroups.map(item => item.code).includes('hotel_reservations')
    },
  },
  watch: {
    '$route.params.roomId': {
      handler(param) {
        this.transactionItems = []
        if (param) this.fetchTransactions()
      },
      immediate: true,
    }
  },
  methods: {
    onExport() {
      this.isExportFolio = true
      getHotelManagementExportFolio(this.$route.params.roomId)
        .then(response => {
          this.$emit('fetchRoom', this.room.status.code)
          this.isExportFolio = false
          window.open(response.data)
        })
    },
    toggleStatus() {
      this.isStatusOpen = !this.isStatusOpen
    },
    onSelectStatus(opt) {
      this.isStatusOpen = false
      if (!opt || opt.code === (this.room.status && this.room.status.code)) return
      console.log(opt)
      patchHotelManagementReservationsRooms(this.$route.params.roomId, {status: opt.code})
        .then(() => {
          this.$emit('statusUpdated')
        })
    },
    formatMoney(num) {
      return `${new Intl.NumberFormat('en-US').format(num)}$`
    },
    formatDate(iso) {
      const d = new Date(iso)
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      return `${ d.getDate() } ${ months[d.getMonth()] }, ${ d.getFullYear() } ${iso.slice(11, 16)}`
    },
    getUserAvatar(crop_url) {
      if (crop_url) return crop_url
      return require('@/assets/img/temp/avatar-slug.jpg')
    },
    handleOutsideClick(e) {
      const root = this.$refs.statusRootFolio
      if (root && !root.contains(e.target)) this.isStatusOpen = false
    },
    onCheckForm(form, action) {
      this.$v[form].$touch()
      if (this.$v[form].$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this[action]()
      }
    },
    onCreatePayment() {
      this.isSubmittingPaymentForm = true
      const data = {...this.paymentForm, reservation: Number(this.$route.params.id), reservation_room: Number(this.$route.params.roomId)}
      if (this.paymentForm?.method !== 'cash') delete this.paymentForm.currency
      postHotelManagementPaymentsCreateSingle(data)
        .finally(() => {
          this.isSubmittingPaymentForm = false
        })
        .then(() => {
          this.$emit('fetchRoom', this.room.status.code)
          this.fetchTransactions()
          this.$modal.hide('payment-form')
        })
    },
    onCreateService() {
      this.isSubmittingServiceForm = true
      const data = {
        ...this.serviceForm,
        transaction_category: this.serviceForm.transaction_category.code,
        reservation: Number(this.$route.params.id),
        reservation_room: Number(this.$route.params.roomId)
      }
      postHotelManagementTransactions(data)
        .finally(() => {
          this.isSubmittingServiceForm = false
        })
        .then(() => {
          this.$emit('fetchRoom', this.room.status.code)
          this.fetchTransactions()
          this.$modal.hide('service-form')
        })
    },
    onVoidTransaction() {
      this.$emit('fetchRoom', this.room.status.code)
      this.fetchTransactions()
    },
    // onSaveGuests() {
    //   this.isSubmittingGuestForm = true
    //   postHotelManagementGuestsV2({...this.guestForm, property: this.rData.property.code})
    //     .then(res => {
    //       postHotelManagementGuestsToReservationV2(this.$route.params.id, res.data.id)
    //         .finally(() => { this.isSubmittingGuestForm = false })
    //         .then(() => {
    //           this.$emit('fetchRoom', this.room.status.code)
    //           this.$modal.hide('guest-form')
    //         })
    //     })
    // },
    onShowModalPayment() {
      this.paymentForm = {}
      this.$v.paymentForm.$reset()
      this.$modal.show('payment-form')
    },
    onShowModalService() {
      getHotelManagementTransactionCategories({debit: true})
        .then(response => {
          this.transaction_categories_options = response.data
          this.serviceForm = {}
          this.$v.serviceForm.$reset()
          this.$modal.show('service-form')
        })
    },
    onShowModalGuests() {
      Promise.all([getGenders(), getCountries(), getFoodPreferences()])
        .then(res => {
          this.genders_options = res[0].data
          this.countries_options = res[1].data
          this.food_preference_options = res[2].data
          this.guestForm = {}
          this.$v.guestForm.$reset()
          this.$modal.show('guest-form')
        })
    },
    async fetchTransactions() {
      const response = await getHotelManagementTransactions({reservation_room: Number(this.$route.params.roomId)})
      this.transactionItems = response.data
    },
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideClick)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick)
  }
}
</script>

<style scoped>
.hm-folio__content {
  border-radius: 16px;
  border: 1px solid #E9E9E9;
  background: #FFF;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.06);
}

.hm-folio__top {
  padding: 30px 20px 0 30px;
}

.hm-folio__bottom {
  padding: 20px 20px 30px 30px;
}

.hm-folio__content-guests {
  display: flex;
  gap: 40px;
}

.hm-folio__content-guest {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.hm-folio__gender {
  width: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.hm-folio__flag {
  flex-shrink: 0;
  width: 19px;
  height: 19px;
  border-radius: 50%;
  border: 1px solid #b5b5b5;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  background: #fff;
  overflow: hidden;
}

.hm-folio__flag--empty {
  background: #efefef;
  border-color: #efefef;
}

.hm-folio__guest-name {
  color: #000;
  font-size: 15px;
  font-family: 'CoreSansCR', sans-serif;
  font-weight: 500;
}

.hm-folio__status {
  position: relative;
}

.hm-folio__status-btn {
  height: 40px;
  border-radius: 30px;
  border: 1px solid #ECEAE5;
  background: #FCFCFC;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 0 14px 0 16px;
  font-family: 'MazzardSoftH', sans-serif;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  outline: none;
}

.hm-folio__status-btn:disabled {
  cursor: default;
}

.hm-folio__status-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.hm-folio__status-caret {
  flex: 0 0 auto;
  opacity: .7;
}

.hm-folio__status-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 20;
  min-width: 180px;
  padding: 12px;
  border-radius: 16px;
  border: 1px solid #E9E9E9;
  background: #FFF;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.06);
}

.hm-folio__status-option {
  margin-bottom: 5px;
  padding: 6px 10px 4px;
  border-radius: 6px;
  font-family: 'MazzardSoftH', sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;

  &:last-child {
    margin-bottom: 0;
  }
}

.hm-folio__status-option:hover,
.hm-folio__status-option--selected {
  background: linear-gradient(180deg, #EEE 0%, #EDEDED 100%);
}

.hm-folio__status-option--selected {
  pointer-events: none;
}

.hm-status-fade-enter-active,
.hm-status-fade-leave-active {
  transition: opacity .12s ease;
}

.hm-status-fade-enter,
.hm-status-fade-leave-to {
  opacity: 0;
}

.hm-folio__total {
  display: grid;
  grid-template-columns: 120px 140px 190px 1fr 90px 90px;
  gap: 10px;
  padding: 12px 20px 12px 30px;
  background-color: #F6F6F6;
  color: #000;
  font-family: 'CoreSansCR', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: normal;
}

.hm-folio__total-val {
  &:nth-child(4) {
    padding-right: 20px;
    text-align: right;
  }

  &:nth-child(5),
  &:nth-child(6) {
    position: relative;

    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: -15px;
      width: 1px;
      height: 100%;
      background-color: #DDD;
    }
  }
}

.hm-folio__balance {
  display: flex;
  align-items: center;
  gap: 5px;
  height: 40px;
  padding: 0 16px;
  border-radius: 7px;
  background-color: #F6F6F6;
  color: #000;
  font-family: 'CoreSansCR', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: normal;
  text-transform: uppercase;
}

.hm-folio__neg {
  color: #A64833;
}

.hm-folio__pos {
  color: #468832;
}

.hm-folio__printed {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #535353;
  font-family: 'CoreSansCR', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
}

.hm-folio__printed-name {
  font-weight: 500;
}

.hm-folio__printed-ava {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  overflow: hidden;
}

.hm-folio__printed-ava-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>